module.exports = __webpack_public_path__ + "static/media/BOI_hero.63c146c8.jpg";